import React, { useCallback } from 'react';
import {
  HeaderIcon,
  NaviIconHome,
  NaviIconSearch,
  StackScreen,
  useStatusBarUpdate,
} from '@banhala/ui-kit';
import { useHandleBackPressed } from 'shared/src/hooks';
import { useGoodsRoute } from '../../hooks/useGoodsRoute';
import { CartIcon } from 'shared/src/component';
import { useNavigator } from 'shared/src/utils';
import { GoodsDetailContents } from './components/GoodsDetailContents';
import { useSetScreenName } from './hooks/useSetScreenName';
import { useLogClickHome } from './hooks/useLogClickHome';
import { useLogClickSearch } from './hooks/useLogClickSearch';

const GoodsDetailPage: React.FC = () => {
  const routes = useGoodsRoute<'GoodsDetail'>();
  const { navigator } = useNavigator();
  const { onPressBack, showBackButton } = useHandleBackPressed(
    routes.params.instanceId,
  );

  useSetScreenName();
  const logClickHome = useLogClickHome();
  const logClickSearch = useLogClickSearch();

  const handleHomeClick = useCallback(() => {
    logClickHome();
    navigator.moveToHome();
  }, [logClickHome, navigator]);
  const handleSearchClick = useCallback(() => {
    logClickSearch();
    navigator.moveToSearch();
  }, [navigator, logClickSearch]);

  useStatusBarUpdate('white');
  return (
    <StackScreen
      hideBackButton={!showBackButton}
      onPressBack={onPressBack}
      backButtonTestID={'뒤로가기버튼'}
      rightIcons={[
        <HeaderIcon testID={'홈버튼'} onPress={handleHomeClick}>
          <NaviIconHome />
        </HeaderIcon>,
        <HeaderIcon testID={'검색버튼'} onPress={handleSearchClick}>
          <NaviIconSearch />
        </HeaderIcon>,
        <CartIcon screen={'GOODS_DETAIL'} />,
      ]}
    >
      <GoodsDetailContents />
    </StackScreen>
  );
};

export default GoodsDetailPage;
